module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 22.456 23.323",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }